import React from 'react'
import ReactPlayer from 'react-player'

export default function WhyUseSection() {
  return (
    <div className='wrapper' style={{ paddingTop: '7rem', paddingBottom: '7rem' }}>
      <h2>Why use privauto?</h2>
      <div className='video-box'>
        <div className='layer'>
          <ReactPlayer
            className='react-player'
            width='100%'
            height='100%'
            src='https://youtu.be/Rrg7mJ2b54I'
          />
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          h2 {
            color: #fff;
          }
          .video-box {
            max-width: 113rem;
            margin: 0 auto;
          }
          .layer {
            padding-top: 56.25%;
            height: 0;
            position: relative;
          }

          :global(.react-player) {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }

          h2 {
            margin: 0 0 4rem;
            text-align: center;
            font-size: 5.4rem;
            line-height: 7.1rem;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            h2 {
              margin: 0 0 1.6rem;
              font-size: 2.2rem;
              line-height: 2.6rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
